/* unplugin-vue-components disabled */import script from "./DongleUserAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./DongleUserAuth.vue?vue&type=script&setup=true&lang=js"

import "./DongleUserAuth.vue?vue&type=style&index=0&id=0fea2c56&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fea2c56"]])

export default __exports__